import React, { useMemo, useState } from 'react';
import { RegistryClient } from '../../types/types';
import { color, font, space } from '../../theme';
import { useBreakpoint } from '../../useBreakpoint';
import { Card, CardHeader } from '../Card';
import Button from '../Button';
import { ClientKindBadge } from './RegistryBits';
import { sortedClients } from './registry';

// Rows shown before "show all": a few lobbyists list 40–70 clients
const PREVIEW = 12;

/* A registered lobbyist's clients, א–ת, each with how it is represented (קבוע/זמני).
   Desktop: two columns. */
const ClientsCard = ({ clients }: { clients: RegistryClient[] }) => {
  const { isDesktop } = useBreakpoint();
  const [expanded, setExpanded] = useState(false);
  const sorted = useMemo(() => sortedClients(clients), [clients]);
  // Hiding only one or two rows behind a button isn't worth the extra tap
  const collapsed = !expanded && sorted.length > PREVIEW + 2;
  const shown = collapsed ? sorted.slice(0, PREVIEW) : sorted;
  const cols = isDesktop ? 2 : 1;

  return (
    <Card padding={0}>
      <div style={{ padding: `${space.lg}px ${space.lg}px ${space.xs}px` }}>
        <CardHeader title="לקוחות" meta={`${sorted.length.toLocaleString('he-IL')} · לפי פנקס השדלנים`} style={{ marginBottom: 0 }} />
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
        {shown.map((c, i) => (
          <li
            key={c.name}
            style={{
              display: 'flex', alignItems: 'center', gap: space.md, minHeight: 48, boxSizing: 'border-box',
              padding: `${space.sm}px ${space.lg}px`,
              borderTop: i >= cols ? `1px solid ${color.divider}` : 'none',
              // RTL: the second column is on the left, so its rule is on its right edge
              borderRight: cols > 1 && i % cols === 1 ? `1px solid ${color.divider}` : 'none',
            }}
          >
            <span style={{ flex: 1, minWidth: 0, fontSize: font.label, color: color.text, lineHeight: 1.4 }}>{c.name}</span>
            <span style={{ flexShrink: 0 }}><ClientKindBadge kind={c.kind} /></span>
          </li>
        ))}
      </ul>
      {collapsed && (
        <div style={{ borderTop: `1px solid ${color.divider}`, padding: space.xs }}>
          <Button variant="ghost" fullWidth onClick={() => setExpanded(true)}>
            הצגת כל {sorted.length.toLocaleString('he-IL')} הלקוחות
          </Button>
        </div>
      )}
    </Card>
  );
};

export default ClientsCard;
